import { API, Auth } from 'aws-amplify';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';

import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/ImageBottomSheetTracking';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const initViewValues = {
  currentIndex: 0,
  bgImage: {
    background: 'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
  },
  bgOpacity: { bgDimmed: 70 },
  radius: { background: 16, button: 32 },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: {
    title: '지금 날씨에 딱인 포근한 데일리 아우터',
    sub_title:
      '감기가 걱정되는 간절기에 당신의 건강과 따스한 온기를 보태줄 데일리 아우터 기획전'
  },
  fontSize: { title: 1.25, sub_title: 0.75 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#828282' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'left', sub_title: 'left' },

  btnText: { button: '상품 보러가기' },
  btnFontSize: { button: 0.875 },
  btnFontWeight: { button: 500 },
  btnColor: { button: '#ffffff' },
  btnBgColorR: { button: 0 },
  btnBgColorG: { button: 0 },
  btnBgColorB: { button: 0 },
  btnBgColorA: { button: 0.7 },
  btnFontFamily: { button: 'Montserrat' }
};

const ImageBottomSheet: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnURL = getFontURL(btnFontFamily?.button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
    };
  }, []);
  // useEffect(() => {
  //   async function getUserId() {
  //     const current = await Auth.currentUserInfo();
  //     setCurrentUser(current.attributes['custom:Company']);
  //   }
  //   getUserId();
  // }, []);

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'subTitle';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

  .root_view {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }
    .modal_wrapper {
      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background});`
          : 'background: rgba(0, 0, 0, 0.8);'
      };
      width: 100%;
      height: 17rem;
      padding: 1rem 10% 1.5rem 10%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;      

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.background}px ${radius?.background}px 0 0;
    }

    .close_btn {
      width: 100%;
      display: flex;
      justify-content: end;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_box {
      height: calc(100% - 2rem);
      margin-top: 0.5rem;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .contents_box .title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.title]};
    }
    .contents_box .title_inner {
      height: auto;
      max-height: 3.5rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }

    .contents_box .sub_title {
      width: 100%;
      height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitle'
      };
    }

    .btn_wrapper button {
      padding: 0.65rem 1rem;
      border: 0;

      cursor: pointer;
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btn'
      };
    }

    ${
      templateWidth > 767
        ? `
        .modal_wrapper {
          height: 29.065rem;
          padding: 2rem 25% 4rem 25%;
        }
        
        .contents_box {
          margin-top: 1.5rem;
        }
        .contents_box .title {
          height: 6rem;
        }
        .title_inner {
          font-size: ${fontSize?.title + 0.125}rem;
        }
        .contents_box .sub_title {
          height: 4rem;
          -webkit-line-clamp: 4;
        }
        `
        : ''
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="modal_wrapper">
          <div className="close_btn">
            <button>close</button>
          </div>
          <div className="contents_box">
            <div>
              <div className="title">
                <div className="title_inner">{changeEnter(text?.title)}</div>
              </div>
              <div className="sub_title">{changeEnter(text?.sub_title)}</div>
            </div>
            <div className="btn_wrapper">
              <button>{btnText?.button}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageBottomSheet;
